import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AppLayout } from '@/layouts/AppLayout';
import { requireTenantUser } from '@/utils/authGuard';

export const Route = createFileRoute('/it-service')({
  beforeLoad: requireTenantUser,
  component: () => (
    <AppLayout>
      <Outlet />
    </AppLayout>
  ),
});
